import { Button } from '@/components/Button';
import { useModal } from '@/hooks/useModal';
import { getAccount, useAccount } from '@/resource/account';
import { isReportedAd, reportAd, type AdItemType } from '@/resource/ad';

export function ReportButton({ ad }: { ad: AdItemType }) {
  const modal = useModal();
  const account = useAccount();
  const isReported = isReportedAd(account, ad);

  return (
    <Button
      icon={isReported ? undefined : 'warning'}
      theme="outline"
      shape="square"
      align="center"
      disabled={isReported}
      onClick={(e, refocus) =>
        modal.open(
          {
            type: 'report',
            props: {
              title: 'Dit bericht is ongepast',
              onCancel: () => modal.close(),
              onReport({ reportReasonId, description }) {
                reportAd({ reportReasonId, description, adId: ad.id })
                  .catch((err) => console.error(err))
                  .then(() => getAccount())
                  .finally(() => modal.close());
              },
            },
          },
          refocus
        )
      }
    >
      {isReported ? 'Gerapporteerd' : 'Melden dat dit niet ok is'}
    </Button>
  );
}
